export default __webpack_public_path__ + "static/media/orion-g-ventilator.fc2d812a.jpg";